'use client';

import { DatadogRumScript } from '@alltrails/stability';
import useOsano from '@alltrails/layout/hooks/useOsano';
import useBraze from '@alltrails/layout/hooks/useBraze';
import useTinuitiPixel from '@alltrails/layout/hooks/useTinuitiPixel';
import AmplitudeBrowserSdk from '@alltrails/layout/scripts/AmplitudeBrowserSdk';
import GoogleOneTap from '@alltrails/layout/components/GoogleOneTap';
import ReturningUserUpsell from '@alltrails/upsell/components/ReturningUserUpsell/ReturningUserUpsell';
import Sprig from '@alltrails/layout/scripts/Sprig';
import useAppleRedirectHandler from '@alltrails/user-auth/hooks/useAppleRedirectHandler';
import useUser from '@alltrails/context/hooks/useUser';
import useScrollAuthHoldoutExposureOnMount from '@alltrails/layout/hooks/useAuthScrollHoldoutExposureOnMount';
import { useSelector } from '@/utils/redux';

const TrailPageAnalytics = () => {
  useOsano();
  useTinuitiPixel();
  useBraze();
  useAppleRedirectHandler();
  useScrollAuthHoldoutExposureOnMount();

  const limitReached = useSelector(state => state.trailPage.viewLimitReached);
  const user = useUser();

  return (
    <>
      <DatadogRumScript />
      <AmplitudeBrowserSdk logDwellTime />
      <Sprig userId={user?.id} />
      {limitReached !== 'uninitialized' && <GoogleOneTap pageViewLimitReached={limitReached} />}
      <ReturningUserUpsell />
    </>
  );
};

export default TrailPageAnalytics;
